<template>
    <el-card class="box-card mb20 pointer" v-loading="dataLoading">
        <div class="top nowrap">
            <h3 class="inline-block">媒体大盘</h3>
            <div class="inline-block">
                <ESelect
                    v-model="formItem.range_time_type"
                    @change="getDataList"
                    placeholder="周期"
                    size="mini"
                    class="select-no-border "
                    style="width: 60px;">
                    <el-option
                        v-for="item in rangeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </ESelect>

                <el-cascader
                    class="cascader-no-border"
                    v-model="formItem.plat_type"
                    :options="platTypeList"
                    :props="{ checkStrictly: true }"
                    @change="getDataList"
                    style="width: 130px;">
                </el-cascader>


                <!--<el-select v-model="formItem.plat_id" @change="getDataList" placeholder="渠道" size="mini" class="select-no-border " style="width: 90px;">-->
                <!--<el-option-->
                <!--v-for="item in platList"-->
                <!--:key="item.id"-->
                <!--:label="item.name"-->
                <!--:value="item.id">-->
                <!--</el-option>-->
                <!--</el-select>-->
                <!--<el-select v-model="formItem.cost_type" @change="getDataList" placeholder="类型" size="mini" class="select-no-border" style="width: 100px;">-->
                <!--<el-option value="" label="类型"></el-option>-->
                <!--<el-option value="4" label="IAP-应用"></el-option>-->
                <!--<el-option value="3" label="IAA-应用"></el-option>-->
                <!--<el-option value="2" label="小游戏"></el-option>-->
                <!--</el-select>-->
            </div>
        </div>
        <div class="middle">
            <p class="tac mb10 nowrap">
                <span class="p20">
                   <span class="tac text-color-success" v-if="ringRate>0">环比：{{barData.ring_rate}} <i class="el-icon-top"></i></span>
                   <span class="tac text-color-error" v-else-if="ringRate<0">环比：{{barData.ring_rate|absVal}} <i class="el-icon-bottom"></i></span>
                   <span class="tac" v-else>环比：{{barData.ring_rate}}</span>
                </span>
                <span class="p20">
                    <span class="tac text-color-success" v-if="sameRate>0">同比：{{barData.same_rate}} <i class="el-icon-top"></i></span>
                    <span class="tac text-color-error" v-else-if="sameRate<0">同比：{{barData.same_rate|absVal}} <i class="el-icon-bottom"></i></span>
                    <span class="tac" v-else>同比：{{barData.same_rate}}</span>
                </span>
            </p>
            <div class="bar-item">
                <div class="label-text">本期</div>
                <div class="bar-con relative">
                    <span class="bar-data-text">{{barData.now.cost}}</span>
                    <div class="bar-bg" :style="{width:barData.now.rate+'%'}"></div>
                </div>
            </div>
            <div class="bar-item">
                <div class="label-text">环比</div>
                <div class="bar-con relative">
                    <span class="bar-data-text">{{barData.ring.cost}}</span>
                    <div class="bar-bg" :style="{width:barData.ring.rate+'%'}"></div>
                </div>
            </div>
            <div class="bar-item">
                <div class="label-text">同比</div>
                <div class="bar-con relative">
                    <span class="bar-data-text">{{barData.same.cost}}</span>
                    <div class="bar-bg" :style="{width:barData.same.rate+'%'}"></div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="chart" id="marketChart"></div>
        </div>
    </el-card>
</template>

<script>
    import * as echarts from 'echarts';
    import { mapState } from 'vuex';
    import API from '@/api/dashboard.js';

    export default {
        name: "MediaMarket",
        props:{
            platList:Array,
            pageType:{
                type: String,
                required:false,
                default:'media',
            },
        },
        data(){
            return {
                dataLoading:false,
                formItem:{
                    range_time_type:'benji',
                    plat_id:'',
                    cost_type:'',
                    plat_type:[],
                },

                rangeList:[
                    // {
                    //     value: 'jinri',
                    //     label: '今日',
                    // },
                    // {
                    //     value: 'zuotian',
                    //     label: '昨日',
                    // },
                    {
                        value: 'benzhou',
                        label: '本周',
                    },
                    {
                        value: 'shangzhou',
                        label: '上周',
                    },
                    {
                        value: 'benyue',
                        label: '本月',
                    },
                    {
                        value: 'shangyue',
                        label: '上月',
                    },
                    {
                        value: 'benji',
                        label: '本季',
                    },
                    {
                        value: 'shangji',
                        label: '上季',
                    },
                    {
                        value: 'bennian',
                        label: '本年',
                    },
                    {
                        value: 'qunian',
                        label: '去年',
                    },
                ],
                barData:{
                    same_rate:'',
                    ring_rate:'',
                    now:{},
                    ring:{},
                    same:{},
                },
                chartData:[],
            }
        },
        computed:{
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
            }),
            ringRate(){
                return parseFloat(this.barData.ring_rate);
            },
            sameRate(){
                return parseFloat(this.barData.same_rate);
            },
            platTypeList(){
                let typeList = [
                    {
                        value: '4',
                        label: 'IAP-应用',
                    },
                    {
                        value: '3',
                        label: 'IAA-应用',
                    },
                    {
                        value: '2',
                        label: '小游戏',
                    },
                ];
                let platArr = this.platList||[];
                return platArr.map(item=>{
                    return {
                        value: item.id,
                        label: item.name,
                        children:[].concat(typeList),
                    }
                })

            },
        },
        mounted(){
            let platId = this.platList.length>0?this.platList[0].id||'':'';
            this.formItem.plat_type = platId?[platId]:[];
            this.getDataList();
            window.addEventListener("resize", this.resizeChart);
        },
        filters:{
            absVal(val){
                if(val==='--') return val;
                if(!val) return '';
                return (val+'').replace(/^-/,'');
            }
        },
        methods:{
            getDataList(){
                this.dataLoading = true;

                let apiMap = {
                    yy:"getYYMediaMarket",
                    media:'getMediaMarket',
                };
                let apiUrl = apiMap[this.pageType]||'getMediaMarket';

                API[apiUrl]({
                    range_time_type:this.formItem.range_time_type,
                    plat_id:this.formItem.plat_type[0]||'',
                    cost_type:this.formItem.plat_type[1]||'',
                }).then(res=>{
                    let resData = res.data||{};

                    this.chartData = resData.cost_date||[];

                    this.barData.now = resData.now||{};
                    this.barData.ring = resData.ring||{};
                    this.barData.same = resData.same||{};
                    this.barData.ring_rate = resData.ring_rate||"";
                    this.barData.same_rate = resData.same_rate||"";

                    this.initChart();


                    this.dataLoading = false;
                },err=>{
                    console.log('getMediaMarket err',err);
                    this.dataLoading = false;
                    this.chartData = [];
                    this.$message.error(err.info||'请求失败')
                })
            },
            initChart(){
                let $chart = document.getElementById('marketChart');
                if(!$chart) return;

                this.marketChart = echarts.init($chart);


                let option = {
                    color:['#a2cfff','#80e7de','#b2b7f6'],
                    title:{
                        text:'总占比情况',
                        top:'center',
                        left:'center',
                        textStyle:{
                            fontSize:12,
                            fontWeight:'normal',
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        appendToBody:true,
                        formatter:(params)=>{
                            let paramsData = params.data||{};
                            return `<p>${paramsData.name}：${paramsData.cost}（${paramsData.rate}）</p>`;
                        },
                    },
                    grid:{
                        left: '3%',
                        right: '4%',
                        bottom: '0',
                        containLabel: true,
                    },
                    label:{
                        formatter:(params)=>{
                            let paramsData = params.data||{};
                            return `${paramsData.name}:${paramsData.rate} \n ${paramsData.cost}`;
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['45%', '65%'],
                            data:this.chartData.map(item=>{
                                return {
                                    value:parseFloat(item.rate),
                                    name:item.plat_username,
                                    rate:item.rate,
                                    cost:item.cost,
                                }
                            }),
                        }
                    ]
                };

                this.marketChart.setOption(option,true);
            },
            resizeChart(){
                if(this.marketChart){
                    this.marketChart.resize();
                }
            },
        },
        watch:{
            sidebarOpened(){
                setTimeout(()=>{
                    this.resizeChart();
                },200);
            },
        },
        beforeDestroy(){
            // 组件销毁之前必须先销毁ECharts实例,否则charts里的tooltip将阴魂不散
            if(this.marketChart){
                this.marketChart.dispose();
            }
            window.removeEventListener("resize", this.resizeChart);
        },
    }
</script>

<style lang="scss" scoped>

    ::v-deep.select-no-border input,
    ::v-deep.cascader-no-border input {
        border: none;
        text-align: right;
        padding: 0 20px 0 10px;
    }
    ::v-deep.select-no-border .el-input__suffix,
    ::v-deep.cascader-no-border .el-input__suffix,{
        right:0;
    }

    .bar-item{
        display: flex;
        margin-bottom: 10px;
        .label-text{
            width: 50px;
            height: 20px;
            line-height: 20px;
            text-align: center;
        }
        .bar-con{
            height: 20px;
            line-height: 20px;
            flex: 1;
            .bar-bg{
                position: absolute;
                width: 90%;
                height: 100%;
                background-color: #ace7e0;
                top: 0;
                left: 0;
                border-radius: 5px;
            }
        }

        .bar-data-text{
            position: relative;
            padding-left: 8px;
            z-index: 2;
        }
    }

    .chart{
        height: 200px;
    }

</style>
